/**
 * UpsellModal — shown when a user tries to access a feature not included in their plan
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '../context/SubscriptionContext';

function UpsellModal({ feature, requiredPlan, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { subscription } = useSubscription();

  const handleUpgrade = () => {
    onClose();
    navigate('/plan-selection', {
      state: { currentSubscription: subscription },
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('upsell.title')}</h2>
          <button type="button" className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <p>
            {t('upsell.featureRequiresPlan', {
              feature: t(`upsell.features.${feature}`, feature),
              plan: t(`planSelection.plans.${requiredPlan}.name`, requiredPlan),
            })}
          </p>
          <p className="text-secondary">{t('upsell.upgradeMessage')}</p>
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            {t('common.cancel')}
          </button>
          <button type="button" className="btn btn-primary" onClick={handleUpgrade}>
            {t('upsell.upgradePlan')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpsellModal;
